<template>
  <!--div style="padding: 0 2%"-->
    <v-row no-gutters justify="center">
      <v-col class="py-0">
        <v-row no-gutters class="py-0">
          <v-col class="pa-3">
            <v-row no-gutters>
              <v-col class="py-0">
                <v-row no-gutters justify="center">
                  <v-expansion-panels accordion multiple :value="[0]">
                    <v-expansion-panel v-for="(item, i) in menu" :key="i" v-model="item.open">
                      <v-expansion-panel-header class="my-1" color="accent">
                        <p depressed class="font-weight-bold text-left text-uppercase text-customizer-exp">{{ item.name }}</p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <component v-if="$route.params.id != undefined" :is="item.component" v-bind:response="eventResponse"></component>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  <!--/div-->
</template>

<script>
import Details from "@/components/dashboard/eventDetails/Details.vue";
import EventDescription from "@/components/dashboard/eventDetails/EventDescription.vue";
import Disclaimer from "@/components/dashboard/eventDetails/Disclaimer.vue";
import EventStat from "@/components/dashboard/eventDetails/EventStat.vue";
import Membership from "@/components/dashboard/eventDetails/Membership.vue";
import EventRaces from "@/components/dashboard/eventDetails/EventRaces.vue";
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from 'vuex';

export default {
  mixins: [apiCalls],
  components: {
    Details,
    EventDescription,
    Disclaimer,
    EventStat,
    Membership,
    EventRaces,
  },
  data() {
    return {
      navigationBGColor: "#FFF",
      event: null,
    };
  },
  computed: {
    ...mapState(['events']),

    menu() {
      return [
        {
          name: this.$t("dashboard.menu.eventDetails.eventDetails"),
          component: "Details",
          open: true,
        },
        {
          name: this.$t("dashboard.menu.eventDetails.eventDescription") + " " + this.$t("dashboard.menu.eventDetails.and") + " " + this.$t("dashboard.menu.eventDetails.disclaimer"),
          component: "EventDescription",
          open: false,
        },
        {
          name: this.$t("dashboard.menu.eventDetails.eventRaces"),
          component: "EventRaces",
          open: false,
        },
        {
          name: this.$t("dashboard.menu.eventDetails.membership"),
          component: "Membership",
          open: false,
        },
        {
          name: this.$t("dashboard.menu.eventDetails.eventStat"),
          component: "EventStat",
          open: false,
        },
      ];
    }
  },
  asyncComputed: {
    eventResponse: async function () {
      var response = await this.api("get", "/api/v1/promoter/eventDetails/getEvent/" + this.$route.params.id);
      this.event = response.message[0];
      this.$store.state.eventname = this.event.eventName;
      this.$store.dispatch("setNameAction");      
      return response;
    },
  },
  created: function () {
    this.navigationBGColor = "#ccc";
  },
};
</script>

<style scope>
.not-card-title {
  color: #2c3e50;
  font-size: 1.25rem;
  width: 90%;
  text-align: left;
}
</style>
